import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Grid } from '@mui/material';
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação
import FeedbackModal from '../../modals/FeedbackModal'; // Modal de feedback (loading, sucesso, erro)
import { createMerchandise, importMerchandise } from '../../../services/api'; // Funções de API

const CriarArtigo = () => {
    const [articleData, setArticleData] = useState({
        name: '',
        category: '',
        reference: '',
        minimum_stock: '',
        maximum_stock: '',
        quantity_per_box: '',
        certificate: '',
        barcode: '',
        guide_number: '',
        guide: ''
    });

    // Estados para controle das modais e feedback
    const [confirmCreateVisible, setConfirmCreateVisible] = useState(false);
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionComplete, setSubmissionComplete] = useState(false);
    const [submissionError, setSubmissionError] = useState(null);

    // Atualiza os dados do formulário e loga o payload
    const handleChange = (e) => {
        const newData = { ...articleData, [e.target.name]: e.target.value };
        setArticleData(newData);
        console.log('Payload atualizado:', newData);
    };

    // Função que chama a API para criar o artigo e fornece feedback visual
    const handleCreateArticle = async () => {
        console.log('Criando artigo com os dados:', articleData);
        setIsSubmitting(true);
        setFeedbackOpen(true);
        setSubmissionError(null);
        try {
            const response = await createMerchandise(articleData);
            console.log('Artigo criado:', response.data);
            setSubmissionComplete(true);
        } catch (error) {
            console.error('Erro ao criar artigo:', error);
            setSubmissionError(error.message || 'Erro desconhecido');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Função para importar os artigos do PHC, agora com feedback visual
    const handleImportArticles = async () => {
        console.log('Iniciando importação de artigos...');
        setIsSubmitting(true);
        setFeedbackOpen(true);
        setSubmissionError(null);
        try {
            const response = await importMerchandise();
            console.log('Artigos importados:', response.data.imported);
            setSubmissionComplete(true);
        } catch (error) {
            console.error('Erro ao importar artigos:', error);
            setSubmissionError(error.message || 'Erro desconhecido');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handlers para a modal de confirmação de criação
    const handleConfirmCreate = () => {
        setConfirmCreateVisible(true);
    };

    const onConfirmCreate = () => {
        setConfirmCreateVisible(false);
        handleCreateArticle();
    };

    const onCancelCreate = () => {
        setConfirmCreateVisible(false);
    };

    // Cabeçalho do Card com dois botões: um para criar e outro para importar artigos
    const header = (
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>Criar Artigo</h2>
            <Button 
                label="Importar Artigos do PHC" 
                icon="pi pi-upload" 
                className="p-button-primary"
                onClick={handleImportArticles}
            />
        </div>
    );

    return (
        <>
            <Card header={header}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="name">Nome</label>
                            <InputText 
                                id="name" 
                                name="name" 
                                value={articleData.name} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="category">Categoria</label>
                            <InputText 
                                id="category" 
                                name="category" 
                                value={articleData.category} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="reference">Referência</label>
                            <InputText 
                                id="reference" 
                                name="reference" 
                                value={articleData.reference} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="minimum_stock">Stock Mínimo</label>
                            <InputText 
                                id="minimum_stock" 
                                name="minimum_stock" 
                                value={articleData.minimum_stock} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="maximum_stock">Stock Máximo</label>
                            <InputText 
                                id="maximum_stock" 
                                name="maximum_stock" 
                                value={articleData.maximum_stock} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="p-field">
                            <label htmlFor="quantity_per_box">Quantidade por Caixa</label>
                            <InputText 
                                id="quantity_per_box" 
                                name="quantity_per_box" 
                                value={articleData.quantity_per_box} 
                                onChange={handleChange} 
                                style={{ width: '100%' }} 
                            />
                        </div>
                    </Grid>
                    {/* Adicione mais campos conforme necessário */}
                    <Grid item xs={12}>
                        <Button 
                            label="Confirmar Criação" 
                            icon="pi pi-check" 
                            className="p-button-success" 
                            onClick={handleConfirmCreate}
                        />
                    </Grid>
                </Grid>

                <ConfirmModal 
                    visible={confirmCreateVisible}
                    message="Deseja confirmar a criação deste artigo?"
                    onConfirm={onConfirmCreate}
                    onCancel={onCancelCreate}
                />
            </Card>

            <FeedbackModal 
                open={feedbackOpen}
                isSubmitting={isSubmitting}
                submissionComplete={submissionComplete}
                error={submissionError}
                onClose={() => {
                    setFeedbackOpen(false);
                    setSubmissionComplete(false);
                    setSubmissionError(null);
                }}
            />
        </>
    );
};

export default CriarArtigo;
